$(document).ready(function () {
    // Si modale présente alors affichage modale
    if ($('#modal-bienvenue').length && (localStorage.getItem('initmodal') != 1)) {
        $('#modal-bienvenue').modal();
        localStorage.setItem('initmodal', 1);
    }

    $('#modal-bienvenue a').click(function () {
        $('#modal-bienvenue').close();
    });
});
